import { render, staticRenderFns } from "./STableLowInventoriesComp.vue?vue&type=template&id=3aff15d7&"
import script from "./STableLowInventoriesComp.vue?vue&type=script&lang=js&"
export * from "./STableLowInventoriesComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports